module.exports = __webpack_public_path__ + "img/logo_ined.0d1472aa.svg";